import React from 'react'

export const GraphPaperIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_802_736)">
        <path
          d="M19 0H0.999996C0.73478 0 0.480426 0.105357 0.292889 0.292893C0.105353 0.48043 -3.8147e-06 0.734784 -3.8147e-06 1V19C-3.8147e-06 19.2652 0.105353 19.5196 0.292889 19.7071C0.480426 19.8946 0.73478 20 0.999996 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V1C20 0.734784 19.8946 0.48043 19.7071 0.292893C19.5196 0.105357 19.2652 0 19 0ZM6 18H2V14H6V18ZM6 12H2V8H6V12ZM6 6H2V2H6V6ZM12 18H8V14H12V18ZM12 12H8V8H12V12ZM12 6H8V2H12V6ZM18 18H14V14H18V18ZM18 12H14V8H18V12ZM18 6H14V2H18V6Z"
          fill="#7E92A2"
        />
      </g>
      <defs>
        <clipPath id="clip0_802_736">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
